// removed by extract-text-webpack-plugin
module.exports = {"sizeXL":"20px","control":"G89a7b0","left":"Ga3d82c G1b59f4 G89a7b0","right":"Ge1e5cc G89a7b0"};